import {DATA_CLOUD_BEFORE_SEND_EVENT} from './consent'
import {ENGAGEMENT_ACTIONS} from './mappers'
import type {GetDataCloudContext} from './types'

type SdkRecord = Record<string, unknown>

const CART_AND_ORDER_TYPES = new Set(['cart', 'cartItem', 'order', 'orderItem'])

// Values the B2C Commerce data kit sent; sourceLocale replaces the SDK's browser locale.
export const CART_SITE_FIELDS = {
  siteId: 'icelandfoodsuk',
  webStoreId: 'icelandfoodsuk',
  sourceLocale: 'default'
}

const isRecord = (value: unknown): value is SdkRecord => Boolean(value) && typeof value === 'object'

/**
 * Adds the fields the abandoned cart trigger needs that the SDK's cart and order records don't have:
 * its engagement action as interactionName, basketId on carts and orders, plus the site fields,
 * basket totals and the image and page URLs of the cart's first line on carts.
 */
export const addCartDetails = (getContext: GetDataCloudContext) => {
  const handler = (event: Event) => {
    const events: unknown = (event as CustomEvent).detail?.events
    if (!Array.isArray(events)) return

    const {basketId, orderedBasketId, basketTotals, getProductLinks} = getContext()
    const records = events.filter(isRecord)
    records.forEach((record) => {
      const action = ENGAGEMENT_ACTIONS[String(record.interactionName)]
      if (action && CART_AND_ORDER_TYPES.has(String(record.eventType))) {
        record.interactionName = action
      }

      if (record.eventType === 'order' && orderedBasketId) record.basketId = orderedBasketId
      if (record.eventType !== 'cart') return

      Object.assign(record, CART_SITE_FIELDS)
      if (basketId) record.basketId = basketId
      if (basketTotals) Object.assign(record, basketTotals)

      const firstLine = records.find(
        (item) => item.eventType === 'cartItem' && item.cartEventId === record.eventId
      )
      if (getProductLinks && typeof firstLine?.catalogObjectId === 'string') {
        const {imageUrl, viewUrl} = getProductLinks(firstLine.catalogObjectId)
        if (imageUrl) record.productImageUrl = imageUrl
        if (viewUrl) record.productViewUrl = viewUrl
      }
    })
  }
  document.addEventListener(DATA_CLOUD_BEFORE_SEND_EVENT, handler)
  return () => document.removeEventListener(DATA_CLOUD_BEFORE_SEND_EVENT, handler)
}
